export const getPageInfo = (pathname) => {
  const routes = {
    "/": { title: "Dashboard", subtitle: "Overview and Key Metrics" },
    "/student": { title: "Students", subtitle: "Student Management" },
    "/student/list": {
      title: "Students List",
      subtitle: "View and manage all students",
    },
    "/student/add": {
      title: "Add Student",
      subtitle: "Add a new student to the system",
    },
    "/parent/new": {
      title: "Create Parent Profile",
      subtitle: "Add a new parent to the system",
    },
    "/team": {
      title: "Team Members",
      subtitle: "Manage your team members and their roles",
    },
    "/team/add": {
      title: "Add Team Member",
      subtitle: "Add a new staff member to your team",
    },
    "/team/profile": {
      title: "Staff Profile",
      subtitle: "View and manage staff information",
    },
    "/events": {
      title: "Calendar",
      subtitle: "Manage your schedule and events",
    },
    "/academics": { title: "Academics", subtitle: "Academic Management" },
    // "/accounts": { title: "Accounts", subtitle: "Financial Management" },
    // "/attendance": {
    //   title: "Attendance",
    //   subtitle: "Track student attendance",
    // },
    // "/analytics": { title: "Analytics", subtitle: "Performance Insights" },
    "/support": { title: "Support", subtitle: "Get help and chat with our team" },
  };

  // Handle dynamic routes
  if (pathname.startsWith("/student/details/")) {
    return {
      title: "Student Details",
      subtitle: "View and manage student information",
    };
  }

  return routes[pathname] || { title: "", subtitle: "" };
};
